/**
 * @author kuan
 */

export const ANALYSIS = {
  'customCover': {category:'export_video', action:'click_custom_cover', label:'导出视频_自定义封面'},
  'customWatermark': {category:'export_video', action:'click_watermark', label:'导出视频_自定义水印'},

  'confirm': {category:'export_video', action:'click_nextstep', label:'导出视频_下一步'},
  'toVIP': {category:'upgrade_members', action:'click_export_upgrade', label:'升级会员_导出视频'},
  'toSVIP': {category:'upgrade_members', action:'click_export_senior_upgrade', label:'升级会员_导出视频_高级会员'},

  watermarkInfo: {
    'none': {category:'upgrade_members', action:'click_export_no_watermark', label:'升级会员_导出_无水印'},
    'custom': {category:'upgrade_members', action:'click_export_custom_watermark', label:'升级会员_导出_自定义水印'},
  },

  pixelInfo: {
    '720p': {category:'upgrade_members', action:'click_export_video_quality_720p', label:'升级会员_导出_视频画质_720'},
    '1080p': {category:'upgrade_members', action:'click_export_video_quality_1080p', label:'升级会员_导出_视频画质_1080'},
  }
}

  export default {
    data () {
      return {
        ANALYSIS,
        useIpLists: []
      }
    },
    mounted() {
      this.$bus.on('getUseIpList', this.getUseIpLists);
    },
    beforeDestroy() {
      this.$bus.off('getUseIpList', this.getUseIpLists);
    },
    methods: {
      reportRadio (item = {}) {
        if (!item.key) {
          return;
        }

        let isShowVIP = item.isVip;
        const collection = {
          ...this.ANALYSIS.watermarkInfo,
          ...this.ANALYSIS.pixelInfo
        };
        if (isShowVIP) {
          collection[item.key] && this.$analysis(collection[item.key])
        } else {
          if (item.key === 'custom') {
            this.$analysis(this.ANALYSIS['customWatermark'])
          }
        }
      },

      getUseIpLists(data) {
        this.useIpLists = data;
        console.log(`Turbo ~ getUseIpLists ~ useIpLists:`, this.useIpLists);
      },

      reportSubmit (currAction) {
        this.ANALYSIS[currAction] && this.$analysis(this.ANALYSIS[currAction]);
      }
    }
  }



// WEBPACK FOOTER //
// ./src/components/mixins/analysis/exportDialog.js